import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import '../styles/HomePage.css';
import shoesBg from '../assets/shoes-bg.jpg';
import toysBg from '../assets/toys-bg.jpg';
import clothesBg from '../assets/Clothes-bg.jpg';

const HomePage = () => {
    const navigate = useNavigate();

    const handleCategoryClick = (category) => {
        if (category === 'toys') {
            navigate('/shop?type=toy');
        } else if (category === 'shoes') {
            navigate('/shoes');
        } else if (category === 'clothes') {
            navigate('/shop?type=clothes');
        }
    };

    useEffect(() => {
    }, []);

    return (
        <div className="home-page">
            <Row className="g-0 flex-nowrap" style={{ flex: 1, minHeight: 0, height: '100%' }}>
                <Col xs={4} className="category-section" style={{ backgroundImage: `url(${shoesBg})`, height: '100%', minHeight: 0, flex: 1, display: 'flex', flexDirection: 'column' }} onClick={() => handleCategoryClick('shoes')}>
                    <div className="category-content"><h2>Обувь</h2></div>
                </Col>
                <Col xs={4} className="category-section" style={{ backgroundImage: `url(${toysBg})`, height: '100%', minHeight: 0, flex: 1, display: 'flex', flexDirection: 'column' }} onClick={() => handleCategoryClick('toys')}>
                    <div className="category-content"><h2>Игрушки</h2></div>
                </Col>
                <Col xs={4} className="category-section" style={{ backgroundImage: `url(${clothesBg})`, height: '100%', minHeight: 0, flex: 1, display: 'flex', flexDirection: 'column' }} onClick={() => handleCategoryClick('clothes')}>
                    <div className="category-content"><h2>Одежда</h2></div>
                </Col>
            </Row>
        </div>
    );
};

export default HomePage; 